
















































import { Component, Vue } from 'vue-property-decorator'
import HomeTile from '@/components/ui/HomeTile.vue'
import AgeSlider from '@/components/ui/AgeSlider.vue'
import '@/icons/glasses'
import '@/icons/profile-home'

@Component({
  components: {
    HomeTile,
    AgeSlider
  }
})
export default class Home extends Vue {
  private background: string = 'style/background.png'
}
